module.exports = __webpack_public_path__ + "img/404.fc24dc2a.jpg";